function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3016",
  "data-name": "Ellipse 3016",
  cx: 13.645,
  cy: 13.645,
  r: 13.645,
  transform: "translate(0 0)",
  fill: "none",
  opacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Ellipse_3017",
  "data-name": "Ellipse 3017",
  d: "M7-8A15,15,0,1,1-8,7,15,15,0,0,1,7-8ZM7,19.692A12.692,12.692,0,1,0-5.692,7,12.692,12.692,0,0,0,7,19.692Z",
  transform: "translate(8 8)",
  fill: "#03001e"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Union_123",
  "data-name": "Union 123",
  d: "M3.445,15.989a1.15,1.15,0,0,1-.4-1.582l2.408-4.031c-.086,0-.174.007-.262.007A5.194,5.194,0,1,1,9.709,7.748l-.031.057L5.025,15.6a1.149,1.149,0,0,1-.992.56,1.132,1.132,0,0,1-.588-.171ZM2.307,5.192A2.883,2.883,0,1,0,5.191,2.306,2.883,2.883,0,0,0,2.307,5.192Z",
  transform: "translate(9.811 7.499)",
  fill: "#03001e"
});

function SvgWhyCardNumberCircleNine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "why_card_number_circle_nine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyCardNumberCircleNine);
export default __webpack_public_path__ + "static/media/why_card_number_circle_nine.020f72b5.svg";
export { ForwardRef as ReactComponent };